var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"mr-1",attrs:{"id":`downloader-button`,"variant":"outline-primary"},on:{"click":function($event){(!_vm.onExport && _vm.runDownload())}}},[_c('feather-icon',{staticClass:"mr-50",attrs:{"icon":"DownloadIcon"}}),_c('span',{staticClass:"align-middle"},[_vm._v(_vm._s(this.$t('Download')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }